import {
  faFaceFrown,
  faFrownOpen,
  faSadCry,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "../styles/NoItemsFound.module.css";
import { useParams, usePathname } from "next/navigation";
import Link from "next/link";
import { category } from "../app/listings/Category";
function NoItemsFound({ clearFilters, page }: any) {
  const pathName = usePathname();
  const params = useParams();

  return (
    <div>
      <div className={`${styles.empty_state} mt-md-5 mt-5 mt-lg-0`}>
        <FontAwesomeIcon color="#ccc" fontSize={"4rem"} icon={faFaceFrown} />
        {page === "shop" ? (
          <>
            {" "}
            <h3 className="">No Shop Found</h3>
          </>
        ) : (
          <>
            {" "}
            <h3 className="">No Items</h3>
            <p>No items are currently available </p>
            {pathName.includes("listings") && (
              <div className="d-flex flex-column align-items-center mt-2">
                <Link
                  href={`/products?category_id=${category[params?.category]}`}
                  className="btn btn-outline-primary"
                >
                  View All Listings
                </Link>
              </div>
            )}
          </>
        )}

        {/* <button onClick={()=>{
      clearFilters("categories")
      
      }} className='btn btn-primary w-75'>Clear Filters</button> */}
      </div>
    </div>
  );
}

export default NoItemsFound;
